import { LAST_5_YEARS } from '@modules/common/constants';
import { useFetchUserCount } from '@modules/common/hooks/useFetchUserCount';
import { formatNumToCompactNotation } from '@modules/common/utils';
import { MetadataFieldMappingMatchCountSkeleton } from '@modules/integrationsV2/components/LinkIntegrationMetadataSection/MetadataFieldMappingList/MetadataFieldMappingMatchCountSkeleton';
import { getWhereClauseForMetadataFieldMapping } from '@modules/integrationsV2/utils';
import { Box, Typography } from '@mui/material';
import { EqlField, TimeUnit } from 'generated/graphql';
import { useMemo } from 'react';
import { TimeRange } from 'v2/core/entities';

interface MetadataFieldMappingUserMatchCountProps {
  sourceEqlField: EqlField;
  targetEqlField: EqlField;
}

export const MetadataFieldMappingUserMatchCount = ({
  sourceEqlField,
  targetEqlField,
}: MetadataFieldMappingUserMatchCountProps) => {
  const queryContainer = useMemo(
    () => ({
      DateRange: LAST_5_YEARS as TimeRange,
      WhereClause: getWhereClauseForMetadataFieldMapping({
        sourceField: sourceEqlField.field,
        targetField: targetEqlField.field,
      }),
      AggregatePeriod: TimeUnit.Month,
    }),
    [sourceEqlField.field, targetEqlField.field],
  );

  const { data: userCount, isLoading: isFetchingUserCount } = useFetchUserCount(
    {
      queryContainer,
    },
  );

  return (
    <Typography
      variant="caption"
      width="100%"
      textAlign="center"
      lineHeight="0.9rem"
      color="text.secondary"
    >
      <Box>
        {!isFetchingUserCount && userCount !== undefined ? (
          formatNumToCompactNotation({
            value: userCount,
            formatSmallerNumToStandardNotation: false,
            maximumFractionDigits: 1,
          })
        ) : (
          <Box mr={0.2} display="inline-block">
            <MetadataFieldMappingMatchCountSkeleton />
          </Box>
        )}{' '}
        user
      </Box>
      <Box>matches</Box>
    </Typography>
  );
};
